@for (block of contentBlocks; track $index) {
  @switch (block.type) {
    @case ('heading') {
      @if (block.level === 1) {
        <h1 [innerHTML]="block.text | formatChat"></h1>
      } @else if (block.level === 2) {
        <h2 [innerHTML]="block.text | formatChat"></h2>
      } @else {
        <h3 [innerHTML]="block.text | formatChat"></h3>
      }
    }
    @case ('paragraph') {
      <p [innerHTML]="block.text | formatChat"></p>
    }
    @case ('link') {
      <p><a [href]="block.url" target="_blank" rel="noopener noreferrer">{{ block.text }}</a></p>
    }
    @case ('list') {
      @if(!block.ordered) {
        <ul>
          @for (item of block.items; track item) {
            <li [innerHTML]="item | formatChat"></li>
          }
        </ul>
      } @else {
        <ol>
          @for (item of block.items; track item) {
            <li [innerHTML]="item | formatChat"></li>
          }
        </ol>
      }
    }
    @case ('divider') {
      <hr class="my-4" />
    }

    @case ('image') {
      <img [src]="block.url" [alt]="block.alt" class="img-fluid my-2" />
    }

    @case ('quote') {
      <blockquote class="blockquote">
        <p>“{{ block.text }}”</p>
        <footer class="blockquote-footer">{{ block.author }}</footer>
      </blockquote>
    }

    @case ('chart') {
      <div class="chart-container my-4">
        <h5>{{ block.title }}</h5>
        @if (block.chartType === 'pie'){
          <apx-chart [series]="block.data.datasets[0].data" [chart]="{ type: block.chartType }" [labels]="block.data.labels"
            [colors]="chartColors">
    </apx-chart>
    } @else {
    <apx-chart [series]="[{
                        name: block.data.datasets[0].label,
                        data: block.data.datasets[0].data
                    }]" [chart]="{ type: block.chartType }" [colors]="chartColors"
      [xaxis]="{ categories: block.data.labels }">
    </apx-chart>
    }
  </div>
  }

  @case ('table') {
    <div class="table-responsive">
      @if (block.caption){
        <h5>{{ block.caption }}</h5>
      }
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
          @for (header of block.headers; track header) {
          <th>{{ header }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of block.rows; track row) {
        <tr>
          @for (cell of row; track cell) {
          <td>{{ cell }}</td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  @case ('Tee_Time_list') {
    <ul class="teetime-list">
    @for (item of block.items; track item) {
    <li>
      <p>
        <i><img class="golf-clock" src="assets/images/teetime-clock.png" /></i>
        {{ item.time }}
      </p>
      <p>
        <i><img class="golf-player" src="assets/images/golf-player.png" /></i>
        {{ item.players }} players
      </p>
      <p>
        <i><img class="golf-hole" src="assets/images/golf-hole.png" /></i>
        {{ item.holes }} holes
      </p>
      <p>
        <i><img class="golf-price" src="assets/images/teetime-price.png" /></i>
        {{ item.price }}
      </p>

      <!-- <a target="_blank" class="mt-2" href="{{ item.bookUrl }}">🗓️ Book Now</a> -->
    </li>
    }
  </ul>

  }

  } <!-- end @switch -->
} <!-- end @for -->

@if (loading) {
<div class="loadingItem">
  <p class="mb-0">
    <i>ssssssssssssssssssssssss</i>
    <i class="ms-1">ssssssssssssssss</i>
    <i>ssssssssssss</i>
    <i class="ms-1">ssssssssssssssss</i>
    <i class="ms-1">sssssssssssssss</i>
  </p>
</div>
}